import React, { JSX } from 'react'

export type SortDirection = 'ascending' | 'descending' | 'none'

const ARROWS: Record<SortDirection, string> = {
  ascending: '▴',
  descending: '▾',
  none: ''
}

export const SortHeader = ({
  label,
  direction,
  onToggle,
  testid
}: {
  label: string
  direction: SortDirection
  onToggle: () => void
  testid?: string
}): JSX.Element => (
  <th aria-sort={direction} className='py-1.5 pr-3' data-testid={testid}>
    <button
      type='button'
      onClick={onToggle}
      title={`Sort by ${label.toLowerCase()}`}
      className='inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider text-dm-text-accent hover:text-dm-text-primary'
    >
      {label}
      {direction !== 'none' && <span aria-hidden='true'>{ARROWS[direction]}</span>}
    </button>
  </th>
)
